"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoisesTask = void 0;
const http_client_1 = require("../lib/http-client");
class MoisesTask {
    constructor(config, session) {
        this.config = config;
        this.session = session;
    }
    async add({ file, operations }) {
        const { data } = await http_client_1.httpClient({
            userToken: this.session.token,
            baseUrl: this.config.apiEndpoint,
            headers: this.config.headers,
        }).post('/v3/task', {
            file,
            operations,
        });
        return data.taskId;
    }
}
exports.MoisesTask = MoisesTask;
